import { LoaderFunction } from 'react-router-dom';
import { client } from '~/api/client';
import { queryData } from '~/api/data/request';
import { loadQuery } from '~/api/data/responses';
import {
  GetTransferDirectoryImportSchemaDocument,
  GetTransferDirectoryImportSchemaQuery,
  GetTransferDirectoryImportSchemaQueryVariables,
  ImportSchemaFieldsFragment,
  GetVoiceAgentCreateContextDocument,
  GetVoiceAgentCreateContextQuery,
  GetVoiceAgentCreateContextQueryVariables,
  GetVoiceAgentDocument,
  GetVoiceAgentLanguageSupportDocument,
  GetVoiceAgentLanguageSupportQuery,
  GetVoiceAgentLanguageSupportQueryVariables,
  GetVoiceAgentQuery,
  GetVoiceAgentQueryVariables,
  GetVoiceAgentsDocument,
  GetVoiceAgentsQuery,
  GetVoiceAgentsQueryVariables,
  VoiceAgentDirection,
  VoiceAgentFieldsFragment,
  VoiceAgentOverviewFieldsFragment
} from '~/api/graphql';

export const getVoiceAgents = async () =>
  queryData<GetVoiceAgentsQuery, GetVoiceAgentsQueryVariables, VoiceAgentOverviewFieldsFragment[]>(
    client,
    { query: GetVoiceAgentsDocument, variables: {} },
    (data) => data?.voiceAgents || []
  );

export const getOutboundVoiceAgents = async () =>
  queryData<GetVoiceAgentsQuery, GetVoiceAgentsQueryVariables, VoiceAgentOverviewFieldsFragment[]>(
    client,
    {
      query: GetVoiceAgentsDocument,
      variables: { filter: { direction: VoiceAgentDirection.Outbound } }
    },
    (data) => data?.voiceAgents || []
  );

export const getVoiceAgent = async (id: string) =>
  queryData<GetVoiceAgentQuery, GetVoiceAgentQueryVariables, VoiceAgentFieldsFragment>(
    client,
    { query: GetVoiceAgentDocument, variables: { id: id } },
    (data) => data?.voiceAgent
  );

export const getTransferDirectoryImportSchema = () =>
  queryData<
    GetTransferDirectoryImportSchemaQuery,
    GetTransferDirectoryImportSchemaQueryVariables,
    ImportSchemaFieldsFragment
  >(
    client,
    { query: GetTransferDirectoryImportSchemaDocument },
    (data) => data?.transferDirectoryImportSchema
  );

export const loadTransferDirectoryImportSchema: LoaderFunction = () =>
  loadQuery(getTransferDirectoryImportSchema());

export const getVoiceAgentLanguageSupport = async () =>
  queryData<
    GetVoiceAgentLanguageSupportQuery,
    GetVoiceAgentLanguageSupportQueryVariables,
    GetVoiceAgentLanguageSupportQuery['voiceAgentLanguageSupport']
  >(
    client,
    { query: GetVoiceAgentLanguageSupportDocument },
    (data) => data?.voiceAgentLanguageSupport
  );

export const getVoiceAgentCreateContext = async () =>
  queryData<
    GetVoiceAgentCreateContextQuery,
    GetVoiceAgentCreateContextQueryVariables,
    GetVoiceAgentCreateContextQuery['agencyUser']
  >(client, { query: GetVoiceAgentCreateContextDocument }, (data) => data?.agencyUser);

export const loadOutboundVoiceAgents: LoaderFunction = () =>
  loadQuery(getOutboundVoiceAgents(), { suppressAuthErrors: true });

export const loadVoiceAgents: LoaderFunction = () =>
  loadQuery(getVoiceAgents(), { suppressAuthErrors: true });

export const loadVoiceAgentCreateContext: LoaderFunction = () =>
  loadQuery(getVoiceAgentCreateContext(), {
    notFoundRedirect: '/app/signin'
  });

export const loadVoiceAgent: LoaderFunction = ({ params }) =>
  loadQuery(getVoiceAgent(params.id || ''));

export const loadVoiceAgentLanguageSupport: LoaderFunction = () =>
  loadQuery(getVoiceAgentLanguageSupport());
